import React from 'react'
import { USER_DOCUMENT_IDS, useUserDocuments } from '@features/userDocuments'
import { Button } from '@shared/components/button'
import { Loading } from '@shared/components/loading'
import cx from 'classnames'

import { BrokerSignContentWrapper } from '../../../shared/broker/content-wrapper'

import { ViewProps } from './model'

import styles from './style.module.scss'

export const View = ({ onNextButtonClick, documentName }: ViewProps) => {
	const { getPdfDataUri } = useUserDocuments()!
	const personalConsentDataUri = getPdfDataUri(USER_DOCUMENT_IDS.UNIFIED_PERSONALIZED_CONSENT)
	const userAgreementDataUri = getPdfDataUri(USER_DOCUMENT_IDS.USER_AGREEMENT)

	return (
		<BrokerSignContentWrapper title='Подтвердите регистрацию'>
			<div className={styles.wrapper}>
				{(!personalConsentDataUri || !userAgreementDataUri) && (
					<div className={styles.loader}>
						<Loading min />
					</div>
				)}
				Нажимая на кнопку «Далее», я даю своё{' '}
				<a
					tabIndex={0}
					target='_blank'
					rel='noopener noreferrer nofollow'
					href={personalConsentDataUri}
					className={cx('main-link', !personalConsentDataUri && 'disabled-pointer-events')}
				>
					{documentName}
				</a>{' '}
				и подтверждаю, что ознакомился и согласен с{' '}
				<a
					tabIndex={0}
					target='_blank'
					rel='noopener noreferrer nofollow'
					href={userAgreementDataUri}
					className={cx('main-link', !userAgreementDataUri && 'disabled-pointer-events')}
				>
					Пользовательским соглашением
				</a>
				.{' '}
				<div className={styles.buttonWrapper} onClick={onNextButtonClick}>
					<Button>Далее</Button>
				</div>
			</div>
		</BrokerSignContentWrapper>
	)
}
